export const siteSettings = {
  name: "Live Market HQ",
  link: "https://livemarkethq.com/",
  email: "support@livemarkethq.com/",
  appLink: "https://app.livemarkethq.com/",
};
